
class MobileMenu {
    constructor() {
      this.menu = document.querySelector('.site-header__nav__links');
      this.burger = document.querySelector(".site-header__burger");
      this.mobileMenuTrigger = document.querySelector(".site-header__burger__trigger");

      this.mobileMenuTrigger = document.querySelector(".site-header__burger__trigger")

      this.events()
    } 
  
    events() {
      this.mobileMenuTrigger.addEventListener("click", () => this.toggleMobileMenu());    
    }
  
    toggleMobileMenu() {
        this.menu.classList.toggle("open");
        this.burger.classList.toggle("close");
    }


  }
  
  export default MobileMenu